module.exports = __webpack_public_path__ + "img/inside_banner.a4819d4.jpg";